import * as React from 'react';

import MixedSelectDropdown from 'components/inputs/mixed-select-dropdown/MixedSelectDropdown';

import type { MixedSelectDropdownItem, MultiSelectItem } from 'types';

type Props = {
  name: string,
  value: string | undefined | null,
  items: Array<MultiSelectItem>,
  placeholder: string,
  disabled?: boolean,
  onChange: (b?: string | null, a?: string | null) => void
};

class AdminMultiSelect extends React.PureComponent<Props> {
  handleOnChange = (items: Array<MixedSelectDropdownItem>) => {
    const { name, onChange } = this.props;

    const selectedValue = items
      .find((item) => item.isSelected)
      ?.value;

    onChange(selectedValue, name);
  };

  render(): React.ReactNode {
    const { name, placeholder, value, items, disabled } = this.props;

    const mappedItems = items.map<MixedSelectDropdownItem>(item => ({
      identifier: item.value ?? '',
      isDisabled: false,
      isSelected: item.value === value,
      label: item.label,
      value: item.value ?? ''
    }));

    return (
      <MixedSelectDropdown
        withSearchable
        withRemovable
        maxItems={1}
        items={mappedItems}
        name={name}
        placeholder={placeholder}
        isDisabled={disabled}
        onItemsToggle={this.handleOnChange}
        onItemsRemove={this.handleOnChange}
        onItemsRemoveAll={this.handleOnChange}
      />
    );
  }
}

export default AdminMultiSelect;
